module.exports = __webpack_public_path__ + "static/media/rede_itau.b312f6e1.svg";